import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import "../css/doc_chem.css";
import { BASE_URL } from '../config';

const DoctorChemistDetails = () => {
    const { id: empId } = useParams();
    const location = useLocation();
    const { 
        fromFieldForce, 
        selectedState, 
        selectedEmployee, 
        tableData,
        states,
        employees
    } = location.state || {};
    const [doctors, setDoctors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { employeeId, type } = useParams();
    const [employeeName, setEmployeeName] = useState('');
    const [dateRange, setDateRange] = useState('');

    useEffect(() => {
        if (location.state?.fromFieldForce) {
            // Try to get the employee name from multiple possible sources
            let matchedEmployee;
            
            // First try: from tableData
            if (location.state.tableState?.tableData) {
                matchedEmployee = location.state.tableState.tableData.find(
                    row => String(row.emp_id) === String(empId)
                );
            }
            
            // Second try: from employees list if not found in tableData
            if (!matchedEmployee && location.state.options?.employees) {
                matchedEmployee = location.state.options.employees.find(
                    emp => String(emp.id) === String(empId)
                );
            }
    
            if (matchedEmployee) {
                const firstName = matchedEmployee.first_name || '';
                const lastName = matchedEmployee.last_name || '';
                setEmployeeName(`${firstName} ${lastName}`);
            } else {
                console.warn("Could not find employee data for ID:", empId);
                console.log("Available data:", {
                    tableData: location.state.tableState?.tableData,
                    employees: location.state.options?.employees
                });
            }
    
            // Date range handling (keep your existing code)
            const from = location.state.filters?.fromDate || '';
            const to = location.state.filters?.toDate || '';
            if (from && to) {
                const formattedFrom = new Date(from).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                });
                const formattedTo = new Date(to).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                });
                setDateRange(`(${formattedFrom} - ${formattedTo})`);
            }
        }
    }, [location.state, empId]);
  
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(
                    `${BASE_URL}/api/combined-retailers/retailers-by-employee/${employeeId}`
                );
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                
                const data = await response.json();
                setDoctors(data);
            } catch (e) {
                setError(e.message);
                setDoctors([]);
            } finally {
                setLoading(false);
            }
        };

        if (employeeId) {
            fetchData();
        }
    }, [employeeId]);

    const handlePrint = () => {
        window.print();
    };

    const handleExportExcel = () => {
        // Implement Excel export logic here
        console.log("Exporting to Excel...");
    };


    const handleReturn = () => {
        navigate('/fieldforcedata', {
            state: {
                fromDocChem: true, // Different flag for the return trip
                ...location.state // Pass along all the original state
            }
        });
    };

    if (loading) {
        return <div>Loading doctor details...</div>;
    }

    if (error) {
        return <div>Error loading doctor details: {error}</div>;
    }

  return (
    <div className="main-container">
        <div className="data-container">
      <div className="heading-container">
        <h1 className="doctor-title">
            Missed Calls -{employeeName ? ` - ${employeeName}` : ''} {dateRange}
        </h1>
      </div>
      <div className="table-container">
          {doctors.length === 0 ? (
            <div className="no-data-message">
              <h3>No Doctor Data Found for Employee ID: {employeeId}</h3>
              <p>Please try another search or verify the employee ID</p>
            </div>
          ) : (
            <table>
                <thead className="text-white">
                    <tr>
                        <th>S.No</th>
                        <th>Type</th>
                        <th>Code</th>
                        <th>Name</th>
                        <th>State</th>
                        <th>City</th>
                        <th>Area</th>
                        <th>Address</th>
                        <th>Added Date</th>
                        <th>Last Visit</th>
                        <th>Total POB</th>
                    </tr>
                </thead>
                <tbody>
                    {doctors.map((retailer, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{retailer.type}</td>
                            <td>{retailer.code}</td>
                            <td>{retailer.name}</td>
                            <td>{retailer.state_name || 'N/A'}</td>
                            <td>{retailer.city_name || 'N/A'}</td>
                            <td>{retailer.area_name || 'N/A'}</td>
                            <td>{retailer.address || 'N/A'}</td>
                            <td>{retailer.added_date ? new Date(retailer.added_date).toLocaleDateString() : 'N/A'}</td>
                            <td>{retailer.last_visit ? new Date(retailer.last_visit).toLocaleDateString() : ''}</td>
                            <td>{retailer.total_pob}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
          )}
        </div>
      
      {/* Add button container */}
      <div className="button-container">
        <button 
          className="return-button"
          onClick={handleReturn}
        >
          Return
        </button>
        <button 
          className="print-button"
          onClick={handlePrint}
        >
          Print
        </button>
        <button 
          className="excel-button"
          onClick={handleExportExcel}
        >
          Excel Export
        </button>
      </div>

      </div>
    </div>
    
  );
};

export default DoctorChemistDetails;